export default __webpack_public_path__ + "static/media/card-mastercard.fcbea258.png";